export function sendMessageToExtension(msg) {
  try {
    return new Promise((resolve, reject) => {
      window.chrome.runtime.sendMessage(
        window._SUPER_EXTENSION_ID || process.env.REACT_APP_CHROME_TAB_ID,
        msg,
        (response) => {
          if (window.chrome.runtime.lastError)
            reject(window.chrome.runtime.lastError.message);
          else resolve(response);
        }
      );
    });
  } catch (e) {
    //
  }
}

export async function desktopAgentExists() {
  const agentExists = await sendMessageToExtension({
    type: "desktopAgentExists",
    source: "superWebApp",
  });
  return agentExists;
}

export async function shouldRestoreChrome() {
  try {
    const res = await desktopAgentExists();
    if (res.desktopAgentExists) {
      const restoreChrome = window.confirm(
        `Click 'Cancel' if you want to execute skill in new incognito window.\n\nClick 'OK' if you want to execute skill in normal window. (Will restore browser if needed)`
      );
      return restoreChrome;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
}
